import styled from "styled-components"

const ContainerAside = styled.aside`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1.25rem;
`

export default ContainerAside
